import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "or-spacer relative h-8 md:w-1/2 w-10/12" }
const _hoisted_2 = { class: "or-spacer-span absolute h-20 w-20 md:w-24 md:h-24 bottom-full left-1/2 rounded-full bg-white md:-mb-12 -mb-10 -ml-10" }
const _hoisted_3 = { class: "absolute rounded-full border-dashed border border-yellow-600 text-center not-italic font-bold flex items-center justify-center inset-1" }
const _hoisted_4 = { class: "md:text-md text-sm uppercase text-pink-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "after:block after:h-7 after:-mt-7 after:mx-auto after:mb-0 after:w-full mask h-8 overflow-hidden" }, null, -1)),
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("i", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ])
    ])
  ]))
}